import { CircleAlert, CircleCheck } from "lucide-react"

export default function CircleProgress({
  percentage,
  size = 16,
  phase
}: {
  percentage: number
  size?: number
  phase: "UPLOADING" | "PROCESSING" | "COMPLETED" | "FAILED"
}) {
  if (phase === "COMPLETED") {
    return (
      <CircleCheck
        size={size}
        className="text-green-600 dark:text-green-500 shrink-0"
      />
    )
  }
  if (phase === "FAILED") {
    return (
      <CircleAlert
        size={size}
        className="text-red-500 dark:text-red-400 shrink-0"
      />
    )
  }

  const radius = size / 2
  const strokeWidth = 2
  const r = radius - strokeWidth / 2
  const circumference = 2 * Math.PI * r
  const pct = Math.max(0, Math.min(100, percentage))
  const offset = circumference - (pct / 100) * circumference
  const ringColor = "stroke-primary dark:stroke-primary-light"

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="shrink-0 -rotate-90"
    >
      <circle
        cx={radius}
        cy={radius}
        r={r}
        className="fill-none stroke-gray-200 dark:stroke-neutral-700"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={radius}
        cy={radius}
        r={r}
        className={`fill-none ${ringColor}`}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  )
}
